import React from "react";
import { FaRegClock, FaBug } from "react-icons/fa";
import { Row, Col, Card, Button, Image, Badge } from "react-bootstrap";
import { FaGooglePlay } from "react-icons/fa";
import { Markup } from "react-render-markup";
import apiEndPoints from "../../../componets/json/apiEndPoints.json";

class Support extends React.Component {
  state = {
    vendors: [],
    loading: {
      status: false,
      text: ""
    }
  };

  loadAuthorizeVendors = async () => {
    //this.setState({ loading: { ...this.state.loading, status: true } });
    const _res = await this.props._api({
      ...this.props,
      method: "get",
      endpoint: apiEndPoints.britex.LookUpValue.vendors_v2,
      param: "",
      /* successText: "" */
    });
    this.setState({ loading: { ...this.state.loading, status: false } });
    if (_res.status == 200) {
      this.setState({ vendors: JSON.parse(this.props._decrypt(_res.data)) });
    }
  }

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaGooglePlay className="c-placeholder c-green" />,
      Title: "Autorizace",
      SubTitle:
        "",
    });
    this.loadAuthorizeVendors();
  }

  render() {
    return (
      <>
        <Row>
          {this.state.loading?.status && (
            <this.props._placeholder line={[{ size: 6 }]} />
          )}
          {this.state.vendors.filter(f => f.isWebAuthorize).map((i, idx) => (
            <Col xs={12}>
              <Card className="mb-2">
                <Card.Body className="d-flex justify-content-center align-items-center">
                  <Row className="mb-4">
                    <Col
                      xs={12}
                      className="d-flex justify-content-center align-items-center h-120"
                    >
                      <Image src={i.webImgLogo ? i.webImgLogo : this.props._defaultImg} className="img-fluid c-support-img" />
                    </Col>
                    <Col xs={12} className="d-flex justify-content-center align-items-center">
                          <span>
                            <h6><strong>{i.FirmName}</strong></h6>
                          </span>
                    </Col>
                    <Col xs={12} className="d-flex justify-content-center align-items-center">
                    <span>
                            <small className="text-muted">
                              {i.webCardText}
                            </small>
                          </span>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

export default Support;
